import React, { Component } from 'react'
import { connect } from 'react-redux'
import { blockUi, unBlockUi } from '../../../actions/actionCreator'
import { FORM_REFS } from '../../../constants'
import { aemHostClient, eapiClient } from '../../../restClient'
import { isEmpty, isEmptyObject, Translations } from '../../../utils'
import DynamicForm from "../../common/Dynamicform/dynamicForm"

class CreateCashFlowForeCasting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cffPageJson: null,
            cffFormData: null
        }
    }

    componentWillMount() {
        this.getCashFlowForecastingPageJson()
    }

    getCashFlowForecastingPageJson = async () => {
        const apiUrl = "/aemData/formData/json_add-cash-flow-forecasting-page"
        const pagejson = await aemHostClient(apiUrl)
        const { data } = pagejson ? pagejson : {}
        if (data) {
            document.title = `${Translations(data.par.aemform_addCashFlowForecastingPage.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}`
            this.setState({ cffPageJson: data })
        }
    }

    saveCashFlowForecasting = async (url, payload) => {
        if (url && !isEmptyObject(payload)) {
            this.props.blockUi();
            const response = await eapiClient(url, {
                method: 'POST',
                data: JSON.stringify(payload)
            })
            if (response) {
                this.props.history.goBack();
                this.props.unBlockUi();
            }
        }
    }

    handleCFFFormCancel = () => {
        this.props.history.goBack();
    }

    getEntityId = (name) => {
        const { entities } = this.props
        if (!isEmptyObject(entities)) {
            return Object.keys(entities).find(entity => entities[entity].entityName === name)
        }
        return ""
    }

    handleCFFFormSubmit = (e, apiUrl) => {
        e.preventDefault();
        if (apiUrl && typeof apiUrl === "string") {
            const caseId = !isEmptyObject(this.state.cffFormData) ? this.state.cffFormData.entity.value : undefined;
            const productType = 'cff';
            const payload = Object.assign({}, { ...this.state.cffFormData, entity: { ...this.state.cffFormData.entity, entityId: this.getEntityId(this.state.cffFormData.entity.name) } }, { caseId }, { productType });
            this.saveCashFlowForecasting(apiUrl, payload)
        }
    }

    handleCFFFormData = (data) => {
        this.setState({ cffFormData: data })
    }

    renderFormFields = () => {
        const properties = {
            caseId: this.props.match.params.caseId,
            formData: {},
            editType: 'add-cash-flow-forecasting',
            pathname: this.props.history.location.pathname
        };
        if (!isEmptyObject(this.state.cffPageJson)) {
            const formRef = FORM_REFS[this.state.cffPageJson.par.aemform_addCashFlowForecastingPage.formRef]
            return (
                <DynamicForm mode={this.props.mode}
                    properties={properties}
                    url={formRef}
                    getFormData={this.handleCFFFormData}
                    onFormSubmit={this.handleCFFFormSubmit}
                    onFormCancel={this.handleCFFFormCancel}
                    lang={this.props.lang.currentLang.lang}
                    translatedData={this.props.lang.translatedData}
                    flag={this.props.lang.currentLangFlag.flag}
                    productList={this.props.cashFlowForecastingProductList}
                    isAssociation={false}
                    productType="cashFlowForecasting"
                />
            );
        }
    }
    render() {
        const { title = "", description = "" } = !isEmptyObject(this.state.cffPageJson) ? this.state.cffPageJson.par.aemform_addCashFlowForecastingPage : {};
        const { lang } = this.props
        return <div className="form-container">
            <div className="form-title">
                <h2 className="form-heading">
                    {Translations(title, lang.currentLang.lang, lang.translatedData)}
                </h2>
                <p className="form-required-desc">
                    {Translations(description, lang.currentLang.lang, lang.translatedData)}
                </p>
            </div>
            {this.renderFormFields()}
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        lang: state.lang,
        cashFlowForecastingProductList: state.productDetails.cashFlowForecasting,
        entities: state.entities
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        blockUi: () => {
            dispatch(blockUi())
        },
        unBlockUi: () => {
            dispatch(unBlockUi())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCashFlowForeCasting)


// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CreateCashFlowForecasting.js